exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".permission__check-icon {\n  font-size: 24px;\n}\n", ""]);

// exports
